import { render, staticRenderFns } from "./ResourceSelector.vue?vue&type=template&id=11cc17f9&"
import script from "./ResourceSelector.vue?vue&type=script&lang=js&"
export * from "./ResourceSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports